var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.onboarding)?_c('div',[(_vm.$store.state.admin.storeId == '33')?_c('OnbordingLE'):(_vm.$store.state.admin.storeId == '26')?_c('OnbordingDADA'):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }